function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Container from "./Container";
import Flex from "./Flex";
import Logo from "./Logo";
import { getPropsFromMap } from "../utils/component";
import { jsx as ___EmotionJSX } from "@emotion/core";

function HeaderLogo(_ref) {
  var name = _ref.name,
      testId = _ref.testId;
  return ___EmotionJSX(Logo, {
    name: name,
    height: "36",
    "height-xs": "40",
    "height-lg": "48",
    maxWidth: "120",
    "maxWidth-xs": "none",
    testId: testId
  });
}

HeaderLogo.propTypes = {
  name: PropTypes.oneOf(Logo.NAMES).isRequired,
  testId: PropTypes.string
};
var DEFAULT_PROPS = {};
Header.DEFAULT_PROPS = DEFAULT_PROPS;
Header.ID = "Header";
Header.HEIGHT_MAP = {
  "default": 56,
  lg: 80
};

function Header(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var children = props.children,
      testId = props.testId;
  var heightMap = Header.HEIGHT_MAP;
  var heightProps = useMemo(function () {
    return getPropsFromMap("height", heightMap);
  }, [heightMap]);
  return ___EmotionJSX("header", {
    "data-testid": testId
  }, ___EmotionJSX(Container, _extends({
    bg: "white"
  }, heightProps, {
    boxShadow: "header"
  }), ___EmotionJSX(Container, {
    hasBreakpointWidth: true,
    height: "100%"
  }, ___EmotionJSX(Flex, {
    height: "100%",
    placeItems: "left center"
  }, children))));
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};
Header.Logo = HeaderLogo;
export default Header;